export const STENCIL_ROUTE_LOADER_DELAY_MS = 2000;
export const STENCIL_ROUTE_LOADER_MIN_VISIBLE_MS = 400;
